module.exports = __webpack_public_path__ + "static/img/facebg.018d553.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebg.png
// module id = 2RiY
// module chunks = 1